import { gql } from '@apollo/client';

export default gql`
  mutation CreateMessage($input: CreateMessageInput) {
    createMessage(input: $input) {
      mId
      mRefId
      mType
      mTitle
      mContent
      mCreatedById
      mCreatedAt
      mUpdatedAt
      mUpdatedById
      convoType
      contentIds
    }
  }
`;
